import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import ModalDialog from '../Components/Modals/ModalDialog';
import { searchUnreadReminders } from '../store/api/ReminderAPI';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { salesReportByMonthOrYear } from '../Sale/store/api/Invoice';
import { getMyLastCommands } from "../Services/store/api/CommandsAPI";
import { useEffect, Fragment, useState, useCallback } from 'react';
import ModalUnreadReminders from '../Components/Modals/ModalUnreadReminders';
import { getTotalServiceCountByMonthOrYear, getServiceWatingForReceptionList, getProductBugReportWithCallback, getServiceCountByStage, getServiceCountByStatus, getServiceDeadlineReportByCallback } from "../Services/store/api/Services";
import { callCountPerMonth, loadLastEvents, newCustomersPerYearOrMonth } from "../CRM/store/api/CustomerApi";
import { BarChart, Bar, YAxis, XAxis, ResponsiveContainer, Legend, CartesianGrid, LineChart, Line, Label } from "recharts";
import { faAddressCard, faBell, faBug, faCalendarCheck, faCalendarDay, faChartBar, faClock, faCommentAlt, faExchangeAlt, faFileInvoice, faPaperPlane, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
import ModalCommands from "../Components/Modals/ModalCommands";
import { getChequesWithCloseDueDateList } from "../Accounting/store/api/DocumentsAPI";
import { useIsMobileApp } from "../store/api/CommonFunctions";
import { PersonBadge, Printer } from "react-bootstrap-icons";


const HomePage = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const [cheqList, setCheqList] = useState({ Data: [] });
    const [commands, getCommands] = useState([]);
    const [events, getEvents] = useState([]);
    const [callCount, getCallCount] = useState([]);
    const [salesCount, getSalesCount] = useState([]);
    const [serviceCount, getServiceCount] = useState([]);
    const [customersCount, getCustomersCount] = useState([]);
    const [serviceWatingList, getServiceWaitingList] = useState([]);
    const [modalCommands, setModalCommands] = useState({ show: false });
    const [sCountByStageList, setSCountByStageList] = useState(null);
    const [sCountByStatusList, setSCountByStatusList] = useState(null);
    const [productBugReport, setProductBugReport] = useState(null);
    const [serviceDeadlineReport, setServiceDeadlineReport] = useState(null);
      const [modalUnreadReminders, setModalUnreadReminders] = useState({ show: false });
    const [unreadReminders, setUnreadReminders] = useState([]);// = useSelector(state => state.UserReducer.unreadReminders);
    const gotoEventHistory = useCallback(() => {
        history.push("/CRM/EventsHistory");
    })
    const gotoCustomer = (item) => {
        if (item.CustomerType === "مشتری بالقوه") {
            history.push("/CRM/AddEditPreCustomer/" + item.CustomerID);
        }
        else {
            history.push("/CRM/AddEditCustomer/" + item.CustomerID);
        }
    }
    const popEvents = (
        <Popover style={{ fontFamily: "Vazir", fontSize: "12px", maxWidth: "100%" }}>
            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faCalendarDay} size="lg" onClick={gotoEventHistory} />&nbsp;
                ده رویداد آخر
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                {events === "PENDING" &&
                    <div style={{ textAlign: "center" }}>
                        <Loader type="BallTriangle" width={30} height={30} className="loader" style={{ margin: "auto" }} />
                    </div>}

                {Array.isArray(events?.Data) &&
                    <div className="scThin" style={{ overflow: "auto" }}>
                        <Table className="designedTable mb-0 mt-0" style={{ "--rowColor": "#defae891", whiteSpace: "nowrap" }}>
                            <thead>
                                <tr>
                                    <th>مشتری/بالقوه</th>
                                    <th>نام مشتری/بالقوه</th>
                                    <th>شرح رویداد</th>
                                    <th>تاریخ پیگیری</th>
                                    <th>ثبت کننده</th>
                                    <th>تاریخ ثبت</th>
                                    <th>ساعت ثبت</th>
                                    <th>نوع رویداد</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                {events.Data.map((row, i) => <tr key={i} onClick={() => gotoEventAttachment(row.AttachmentType, row.AttachmentID, row.Description)}>
                                    <td>{row.CustomerType}</td>
                                    <td>{row.CustomerName}</td>
                                    <td>{row.Description}</td>
                                    <td>{row.PNextDate}</td>
                                    <td>{row.CreateByName}</td>
                                    <td>{row.PCreationDate}</td>
                                    <th>{row.CreationHour}</th>
                                    <td>{row.EventTypeName}</td>
                                    <td className="tooltipCol"><PersonBadge size={18} className="rowBtn" data-tooltip="پرونده مشتری/بالقوه" color="blue" onClick={() => gotoCustomer(row)} /><span className="tooltipSpan" style={{ pointerEvents: "none" }}>پرونده مشتری</span> </td>
                                </tr>)}
                            </tbody>
                        </Table>
                    </div>
                }
            </Popover.Content>
        </Popover>
    )
    const getPath = (x, y, width, height) => `M${x},${y + height}
    C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3} ${x + width / 2}, ${y}
    C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
    Z`;
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <Fragment>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("InstallCount", "نصب ها").replace("RepairCount", "تعمیرها").replace("Count", "تعداد")}
                        </span>
                    ))
                }
            </Fragment>
        );
    }
    const TriangleBar = (props) => {
        const { fill, x, y, width, height, payload, tooltipPayload } = props;

        return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} style={{ cursor: "pointer" }} />;
    };
    const goToSearchInvoice = useCallback(() => {
        history.push("/Sale/SearchInvoice");
    })
    const goToSearchService = useCallback(() => {
        history.push("/Services/MyTasks");
    })
    const goToSearchCustomers = useCallback(() => {
        history.push("/CRM/SearchCustomer");
    })
    const resetCallCount = useCallback(() => {
        callCountPerMonth("", getCallCount);
    })
    const gotoEventAttachment = useCallback((attachmentType, attachmentID, desc) => {
        if (desc.includes("حذف")) {
            return;
        }
        if (attachmentType === "Sale" ||
            attachmentType === "PreSale" ||
            attachmentType === "Purchase" ||
            attachmentType === "PrePurchase" || attachmentType?.includes("Formal")) {
            const isFormal = attachmentType.includes("Formal");
            history.push(`/Sale/Invoice/${attachmentType.replace("Formal", "")}/${attachmentID}/${isFormal}`)
        }
        else if (attachmentType === "repair" || attachmentType === "install") {
            history.push(`/Services/Service/${attachmentID}/${attachmentType}`);
        }
    })

    const showCommand = useCallback((id) => {
        //history.push("/Services/Commands/" + id + "/0/0");
        setModalCommands({
            show: true,
            id: id
        })
    })
    const gotoMyCommands = useCallback(() => {
        history.push("/Services/MyCommands");
    })
    const gotoReminders = useCallback(() => {
        setModalUnreadReminders({ show: true });
    });
    const showService = useCallback((item) => {
        history.push(`/Services/Service/${item.ServiceID}/${item.ServiceType}`, null);
    });
    function gotoSearchCheques() {
        history.push("/Accounting/SearchCheques");
    }
    function gotoCallHistory() {
        history.push("CRM/CallHistory");
    }
    function printDeadlines(e) {
        history.push({
            pathname: `/PrintViewer/DeadlineReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetServiceDeadlineReport?staffID=0&agencyID=null`,
                method: "get"
            }
        });
    }
    function showReminderAttachment(reminder) {
        switch (reminder.AttachmentType) {
            case "customer":
                window.open(`/CRM/AddEditCustomer/${reminder.AttachmentID}`);
                break;
            case "pre_customer":
                window.open(`/CRM/AddEditPreCustomer/${reminder.AttachmentID}`);
                break;
            case "acc_doc":
                window.open(`/Accounting/AddEditDocument/${reminder.AttachmentID}`);
                break;
            case "install":
                window.open(`/Services/Service/${reminder.AttachmentID}/install`);
                break;
            case "repair":
                window.open(`/Services/Service/${reminder.AttachmentID}/repair`);
                break;
            default:
                if (reminder.AttachmentType.includes("Invoice")) {
                    const invoiceType = reminder.AttachmentType.replace("Invoice", "");
                    const isFormal = reminder.AttachmentType.includes("Formal");
                    window.open(`/Sale/Invoice/${invoiceType}/${reminder.AttachmentID}/${isFormal}`)
                }
        }
    }
    useEffect(() => {
        document.body.classList = "mainPage";
        salesReportByMonthOrYear(true, " ", getSalesCount);
        getTotalServiceCountByMonthOrYear(true, "", getServiceCount);
        newCustomersPerYearOrMonth(false, "", getCustomersCount);
        callCountPerMonth("", getCallCount);
        loadLastEvents({ Take: 10, Skip: 0 }, getEvents);
        getMyLastCommands({ Take: 10 }, getCommands);
        getServiceWatingForReceptionList(getServiceWaitingList);
        getChequesWithCloseDueDateList(setCheqList);
        setSCountByStageList("PENDING");
        getServiceCountByStage("", "", "", "", "", setSCountByStageList);
        getServiceCountByStatus({}, setSCountByStatusList);
        getProductBugReportWithCallback({ GroupOnProductType: true }, true, setProductBugReport);
        getServiceDeadlineReportByCallback(setServiceDeadlineReport);
        dispatch(searchUnreadReminders(0, setUnreadReminders));
    }, []);
    return (
        <Fragment>
            <ModalDialog />
            <ModalCommands popData={modalCommands} setPopData={setModalCommands} />
            <ModalUnreadReminders popData={modalUnreadReminders} setPopData={setModalUnreadReminders} />
            <div className="container-fluid">
                <br />
                <Row className="mt-1">
                    <Col md={4}>
                        <Card className="newCard" style={{ "--mainColor": "#0042f3cc", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faCommentAlt} size="lg" onClick={gotoMyCommands} />
                                    &nbsp;
                                    <span className="cardTitle">دستور کارهای اخیر من</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {commands === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {commands && commands.List && Array.isArray(commands.List) &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#dedffa91" }}>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {commands.List.map((row, i) =>
                                                    <tr key={i} onClick={() => showCommand(row.ID)}>
                                                        <td style={{ minWidth: "70px" }}>{row.pCreationDate}</td>
                                                        <td style={{ minWidth: "70px" }}>{row.Subject}</td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="newCard" style={{ "--mainColor": "#e21da3", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faBell} size="lg" onClick={gotoReminders} />
                                    &nbsp;
                                    <span className="cardTitle">  ده یادآوری اخیر من</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {unreadReminders === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {unreadReminders && unreadReminders.Data && Array.isArray(unreadReminders.Data) &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#fadef791" }}>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {unreadReminders.Data.map((row, i) =>
                                                    <tr key={i} onClick={() => showReminderAttachment(row)}>
                                                        <td style={{ minWidth: "70px" }}>{row.PAlarmDate}</td>
                                                        <td>{row.RemBody}</td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="newCard" style={{ "--mainColor": "#4498a1", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <OverlayTrigger overlay={popEvents} trigger="click" rootClose placement={isMobile ? "top" : "bottom"}>
                                        <FontAwesomeIcon icon={faCalendarDay} size="lg" /*onClick={gotoEventHistory}*/ />
                                    </OverlayTrigger>
                                    &nbsp;
                                    <span className="cardTitle">ده رویداد آخر</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {events === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {events && events.Data && Array.isArray(events.Data) &&
                                    <div style={{ maxHeight: "220px", overflow: "auto" }} className="scThin">
                                        <Table className="designedTable mb-0 mt-0" style={{ "--rowColor": "#defae891", whiteSpace: "nowrap" }}>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {events.Data.map((row, i) => <tr key={i} onClick={() => gotoEventAttachment(row.AttachmentType, row.AttachmentID, row.Description)}>
                                                    <td>{row.CustomerName}</td>
                                                    <td>{row.Description}</td>
                                                </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                </Row>
                <Row className="g-4 mt-1">
                    <Col md={6}>
                        <Card className="newCard" style={{ "--mainColor": "#4f3ebc", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faPaperPlane} size="lg" onClick={goToSearchService} />
                                    &nbsp;
                                    <span className="cardTitle"> درخواست های منتظر پذیرش</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {serviceWatingList === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {serviceWatingList?.Data && Array.isArray(serviceWatingList.Data) &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#e2d9ff80" }}>
                                            <thead style={{ backgroundColor: "#d1afea" }}>
                                                <tr>
                                                    <th style={{ padding: "4px" }}>نوع سرویس</th>
                                                    <th style={{ padding: "4px" }}>شماره سرویس</th>
                                                    <th style={{ padding: "4px" }}>مشخصات محصول</th>
                                                    <th style={{ padding: "4px" }}>نام مشتری</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {serviceWatingList.Data.map((row, i) => <tr key={i} onClick={() => showService(row)}>
                                                    <td style={{ minWidth: "70px" }}>{row.ServiceTypePersianText}</td>
                                                    <td>{row.InvoiceNumber}</td>
                                                    <td>{row.ProductName + "-" + row.ProductModel}</td>
                                                    <td>{row.CustomerName}</td>
                                                </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="newCard" style={{ "--mainColor": "#4482c0", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faCalendarDay} size="lg" onClick={gotoSearchCheques} />
                                    &nbsp;
                                    <span className="cardTitle">سررسید چک ها</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {cheqList === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {Array.isArray(cheqList?.Data ?? "") &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#d9e8ff80" }}>
                                            <thead style={{ backgroundColor: "#afc6ea" }}>
                                                <tr>
                                                    <th style={{ padding: "4px" }}>شماره چک</th>
                                                    <th style={{ padding: "4px" }}>تاریخ سررسید</th>
                                                    <th style={{ padding: "4px" }}>نام بانک و شعبه</th>
                                                    <th style={{ padding: "4px" }}>شماره حساب جاری</th>
                                                    <th style={{ padding: "4px" }}>مبلغ چک</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {cheqList.Data.map((row, i) =>
                                                    <tr key={i} style={{ color: row.Color }}>
                                                        <td>{row.ChequeNumber}</td>
                                                        <td>{row.PDueDate}</td>
                                                        <td>{row.BankName}</td>
                                                        <td>{row.BankAccountNo}</td>
                                                        <td>{Number(row.ChequeAmount ?? 0).toLocaleString("en")}</td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                </Row>
                <Row className="g-4 mt-1">
                    <Col md={5}>
                        <Card className="newCard" style={{ "--mainColor": "#c80971", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faFileInvoice} size="lg" onClick={goToSearchInvoice} />
                                    &nbsp;
                                    <span className="cardTitle">آمار ماهانه فروش امسال</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    salesCount === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {salesCount && Array.isArray(salesCount) && salesCount.length > 0 &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                        <LineChart data={salesCount}>
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} padding={{ left: 15 }} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid />
                                            <Line dataKey="Count" type="linear" fill="blue" label={{ position: 'top' }} isAnimationActive={false} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={7}>
                        <Card className="newCard" style={{ "--mainColor": "#6b21a9", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faCalendarCheck} size="lg" onClick={goToSearchService} />
                                    &nbsp;
                                    <span className="cardTitle">کارهای انجام شده سال جاری</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    serviceCount === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {serviceCount && Array.isArray(serviceCount) &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                        <BarChart data={serviceCount}>
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="ContactMonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid />
                                            <Bar dataKey="InstallCount" fill="#05386b" label={{ position: 'top' }} isAnimationActive={false} />
                                            <Bar dataKey="RepairCount" fill="#e54809" label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={7}>
                        <Card className="newCard" style={{ "--mainColor": "#f64600e6", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faPhoneSquare} size="lg" onClick={gotoCallHistory} />
                                    &nbsp;
                                    <span className="cardTitle">تماس ها به تفکیک ماه</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    callCount === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {callCount && Array.isArray(callCount) && callCount.length > 0 &&
                                    <ResponsiveContainer debounce={300}>
                                        <BarChart data={callCount} className="barChart">
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                            <CartesianGrid />
                                            <Bar shape={TriangleBar} dataKey="Count" fill="#468d94" label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={5}>
                        <Card className="newCard" style={{ "--mainColor": "#098ac8", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faAddressCard} size="lg" onClick={goToSearchCustomers} />
                                    &nbsp;
                                    <span className="cardTitle">مشتریان جدید به تفکیک سال</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {
                                    customersCount === "PENDING" &&
                                    <Loader type="BallTriangle" width={30} height={30} className="loader" />
                                }
                                {customersCount && Array.isArray(customersCount) &&
                                    <ResponsiveContainer width="100%" height="100%" debounce={300}>
                                        <LineChart data={customersCount} className="barChart">
                                            <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="Year" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} padding={{ left: 15 }} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid />
                                            <Line dataKey="Count" type="monotone" stroke="#bd2070" label={{ position: 'top' }} isAnimationActive={false} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="newCard" style={{ "--mainColor": "#4498a1", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title style={{ cursor: "pointer" }}>
                                    <FontAwesomeIcon icon={faExchangeAlt} size="lg" onClick={() => history.push("/Services/ServiceCountByStageReport")} />&nbsp;
                                    <span className="cardTitle">
                                        ورود و خروج سیستم خدمات
                                    </span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                {sCountByStageList?.Data &&
                                    <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                        <BarChart data={sCountByStageList.Data}>
                                            <XAxis dataKey="Stage" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100}>
                                                <Label value="مرحله سرویس" offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                            </XAxis>
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                                label={{ value: "تعداد", angle: 90, style: { fill: "blue" } }} />
                                            <CartesianGrid />
                                            <Bar dataKey="Count" fill="#008062" label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="newCard" style={{ "--mainColor": "#c80971", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title style={{ cursor: "pointer" }}>
                                    <FontAwesomeIcon icon={faChartBar} size="lg" onClick={() => history.push("/Services/ServiceCountByStatusReport")} />&nbsp;
                                    <span className="cardTitle">گزارش تعدادی وضعیت سرویس ها</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>
                            <Card.Body>
                                {sCountByStatusList?.Data &&
                                    <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                        <BarChart data={sCountByStatusList.Data}>
                                            <Legend align="left" content={renderLegend} verticalAlign="bottom" />
                                            <XAxis dataKey="Status" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                            <CartesianGrid />
                                            <Bar dataKey="InstallCount" fill="#800053" label={{ position: 'top' }} isAnimationActive={false} />
                                            <Bar dataKey="RepairCount" fill="#bb54a0" label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={12}>
                        <Card className="newCard" style={{ "--mainColor": "#098ac8", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faBug} size="lg" onClick={() => history.push("/Services/ProductBugReport")} />&nbsp;
                                    <span className="cardTitle">
                                        گزارش ایرادات محصول به تفکیک نوع محصول
                                    </span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>
                            <Card.Body>
                                {productBugReport?.Data?.length > 0 &&
                                    <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                        <BarChart data={productBugReport.Data}>
                                            <XAxis dataKey="ProductName" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} height={50} angle={-18} tickMargin={6}>
                                                <Label value={"نوع محصول"} offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                            </XAxis>
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                                label={{ value: "تعداد", angle: 90, style: { fill: "blue" } }} />
                                            <CartesianGrid />
                                            <Bar dataKey="Count" fill="#4b75bd" label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                    {Array.isArray(serviceDeadlineReport ?? "") &&
                        <Col md={6} style={{ height: "340px" }}>
                            <Card className="newCard" style={{ "--mainColor": "#4f3ebc", height: "310px" }}>
                                <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                    <Card.Title>
                                        <FontAwesomeIcon icon={faClock} size="lg" />&nbsp;
                                        <span className="cardTitle">
                                            موعد سرویس ها
                                            <Printer size={20} className="rowBtn" onClick={printDeadlines} style={{ float: "left", cursor: "pointer" }} />
                                        </span>
                                    </Card.Title>
                                    <div className="sepLine"></div>
                                </Card.Header>
                                <Card.Body className="scThin" style={{ overflowY: "auto", paddingTop: 0, paddingBottom: 0 }}>
                                    <Table className="mb-0 mt-0" style={{ whiteSpace: "noWrap", overflow: "auto", width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>نوع</th>
                                                <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>شماره</th>
                                                <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>وضعیت سرویس</th>
                                                <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>موعد سرویس</th>
                                                <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>اولویت</th>
                                                {!isMobile &&
                                                    <Fragment>
                                                        <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>نام کالا</th>
                                                        <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>تکنسین اعزامی</th>
                                                        <th style={{ position: "sticky", top: 0, background: "#699bcf" }}>اظهارات مشتری</th>
                                                    </Fragment>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                serviceDeadlineReport.map((item, i) => {
                                                    return (
                                                        <tr key={i} style={{ background: item.BGColor, cursor: "pointer" }} onClick={() => {
                                                            showService(item)
                                                        }}>
                                                            <td>{item.PServiceType}</td>
                                                            <td>{item.InvoiceNumber}</td>
                                                            <td>{item.Status}</td>
                                                            <td>{item.PServiceDeadline}</td>
                                                            <td>{item.PriorityForWorkshop_Str}</td>
                                                            {!isMobile &&
                                                                <Fragment>
                                                                    <td>{item.ProductName}</td>
                                                                    <td>{item.StaffName}</td>
                                                                    <td>{item.CustomerDescription}</td>
                                                                </Fragment>
                                                            }
                                                        </tr>)
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                    }
                </Row>
            </div>
        </Fragment>

    )

}

export default HomePage;